import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, toDisplayString as _toDisplayString, createVNode as _createVNode, createTextVNode as _createTextVNode, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-0de9870c"), n = n(), _popScopeId(), n);
const _hoisted_1 = { class: "flex-box" };
import { useStore } from '@/store/store';
import { ref, watch } from 'vue';
import { decimalizeByExchange } from '@/logics/utils';
import MaterialIcon from '@/materials/atoms/MaterialIcon.vue';
import Spread from '@/materials/atoms/Spread.vue';
export default /*#__PURE__*/ _defineComponent({
    props: {
        latestValue: null,
        spread: null
    },
    setup(__props) {
        const props = __props;
        const store = useStore();
        const latest = ref(Number(props.latestValue));
        const color = ref('var(--trade-order-middle)');
        const volaClass = ref('trending_flat');
        watch(() => store.state.latestValue, () => {
            if (latest.value > store.getters.latestValue) {
                volaClass.value = 'arrow_downward';
                color.value = 'var(--trade-order-short)';
            }
            else if (latest.value < store.getters.latestValue) {
                volaClass.value = 'arrow_upward';
                color.value = 'var(--trade-order-long)';
            }
            else {
                volaClass.value = 'trending_flat';
                color.value = 'var(--trade-order-middle)';
            }
            latest.value = store.getters.latestValue;
        });
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createElementVNode("div", {
                    class: "contract",
                    style: _normalizeStyle(`color: ${color.value}`)
                }, [
                    _createTextVNode(_toDisplayString(_unref(decimalizeByExchange)(latest.value, _unref(store).getters.symbol.pair, _unref(store).state.currencyPairInfo)) + " ", 1),
                    _createVNode(MaterialIcon, {
                        name: volaClass.value,
                        class: "icon"
                    }, null, 8, ["name"])
                ], 4),
                _createVNode(Spread, {
                    class: "text-style flex-item",
                    spread: props.spread
                }, null, 8, ["spread"])
            ]));
        };
    }
});
